import { PropsWithChildren, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";

import { useEventCommunicator } from "@/v2/hooks/useEventCommunicator";
import { useUserStore } from "@/v2/store/useUserStore";
import { authentication } from "@/v2/utils/authentication";

export const LoginProtectedRoutes = ({ children }: PropsWithChildren) => {
  const user = useUserStore((state) => state.user);
  const login = useUserStore((state) => state.login);
  const { authState } = useOktaAuth();
  const { eventEmitter } = useEventCommunicator();

  // @ts-ignore
  // for reviewer: for debug purposes, will delete when going to prod
  window.auth = authentication;

  useEffect(() => {
    eventEmitter({ type: "AUTH_STATE_CHANGED", data: authState });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState]);

  useEffect(() => {
    const oktaLocalData = localStorage.getItem("okta-token-storage");

    const oktaParsedData = JSON.parse(oktaLocalData || "{}");

    if (!oktaParsedData?.accessToken?.value) {
      eventEmitter({ type: "AUTH_STATE_CHANGED", data: authState });
      authentication.login();
    } else if (!user) {
      eventEmitter({ type: "AUTH_STATE_CHANGED", data: authState });
      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, login]);

  if (!user) return "";

  return children;
};
